import Vue from 'vue'
import Axios from './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import i18n from './i18n'
import store from './store'
import Swagger from "../../app/src/plugins/swagger";
import  Oauth2 from "../../app/src/plugins/auth";
// import VueAxios from 'vue-axios'

import './style/main.scss'
import '../src/icons' // icon
Vue.use(Swagger);
// Vue.use(VueAxios, axios);
Vue.use(Axios);
Vue.use(Oauth2.Oauth2ClientPlugin);
Vue.config.productionTip = false
let vm = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
    // eslint-disable-next-line
    if (to.matched.some(r => r.meta.requiresAuth)) {
        if (!vm.$oauth2.isAuthenticated()) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next();
        }
    } else {
        next();
    }
});

